var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 278,
    viewBox: "0 0 202 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2250_701",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 202,
    height: 276
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 201.785,
    height: 275.685,
    fill: "#F1A51C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2250_701)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -66.311,
    y: -0.974609,
    width: 303.747,
    height: 276.659,
    fill: "#972682"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 202,
    height: 9.22332,
    fill: "#781065"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 62.4463,
    width: 202,
    height: 9.22332,
    fill: "#781065"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 80.8936,
    width: 202,
    height: 9.22332,
    fill: "#781065"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 99.3398,
    width: 202,
    height: 9.22332,
    fill: "#781065"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 117.786,
    width: 202,
    height: 9.22332,
    fill: "#781065"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 136.233,
    width: 202,
    height: 9.22332,
    fill: "#781065"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.912 211.988C125.912 245.068 99.107 271.868 66.0224 271.868C32.9378 271.868 6.13293 245.068 6.13293 211.988C6.13293 178.908 32.9378 152.107 66.0224 152.107C99.0825 152.083 125.912 178.908 125.912 211.988Z",
    fill: "#781065"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9981 277.977C29.6148 277.977 0 248.366 0 211.988C0 175.61 29.6148 146 65.9981 146C102.381 146 131.996 175.61 131.996 211.988C132.021 248.366 102.406 277.977 65.9981 277.977ZM65.9981 158.191C36.3344 158.191 12.2173 182.329 12.2173 211.964C12.2173 241.623 36.3588 265.737 65.9981 265.737C95.6374 265.737 119.779 241.599 119.779 211.964C119.803 182.329 95.6618 158.191 65.9981 158.191Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBit);
export default __webpack_public_path__ + "static/media/Bit.498e9e305333f3ee9c7e6e7f54bca381.svg";
export { ForwardRef as ReactComponent };